import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

export default () => {
	Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

	function getElementOffset(el) {
		let top = 0;
		let left = 0;
		let element = el;
	  
		// Loop through the DOM tree
		// and add it's parent's offset to get page offset
		do {
		  top += element.offsetTop || 0;
		  left += element.offsetLeft || 0;
		  element = element.offsetParent;
		} while (element);
	  
		return {
		  top,
		  left,
		};
	}

	if(document.querySelectorAll('.module--frontpageHeader .swiper').length && document.querySelectorAll('.module--frontpageHeader .swiper .swiper-slide').length > 1)
	{
		let frontSlider = new Swiper('.module--frontpageHeader .swiper', {
			loop: true,
			effect: 'fade',
			slidesPerView: 1,
			autoplay: {
			  delay: 5000,
			  disableOnInteraction: false,
			},
		  });
		  
		if (frontSlider !== null && frontSlider.slides && frontSlider.slides.length > 0) {
		function frontSlideChangedHandler() {
			let slide = document.querySelectorAll('.module--frontpageHeader .swiper .swiper-slide-active');
			if (slide.length) {
			slide = slide[0];
			let videos = document.querySelectorAll('.module--frontpageHeader .swiper .swiper-slide video');
			videos.forEach(el => {
				try {
				el.pause();
				} catch (error) {
				// Handle any potential errors when pausing videos
				}
			});
		
			let activeVideo = slide.querySelectorAll('.module--frontpageHeader .swiper .swiper-slide-active video');
			try {
				activeVideo[0].play();
			} catch (error) {
				// Handle any potential errors when playing videos
			}
			}
		}
		
		frontSlider.on('transitionEnd', function () {
			frontSlideChangedHandler();
		});
		}
	}
	
	if(document.querySelectorAll('.module--articlesImageGallery .swiper').length && document.querySelectorAll('.module--articlesImageGallery .swiper .swiper-slide').length > 1)
	{
		let gallerySlider = new Swiper('.module--articlesImageGallery .swiper', {
			spaceBetween: 0,
			slidesPerView: 1,
			loop: true,
			centeredSlides: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},
			navigation: {
				nextEl: '.module--articlesImageGallery .swiper .btn-next',
				prevEl: '.module--articlesImageGallery .swiper .btn-prev',
			}
		});
	}
	
	if(document.querySelectorAll('.module--articleHero .swiper').length && document.querySelectorAll('.module--articleHero .swiper .swiper-slide').length > 1)
	{
		let heroSlider = new Swiper('.module--articleHero .swiper', {
			spaceBetween: 0,
			slidesPerView: 1,
			loop: true,
			centeredSlides: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			}
			// navigation: {
			// 	nextEl: '.module--articleHero .swiper .btn-next',
			// 	prevEl: '.module--articleHero .swiper .btn-prev',
			// }
		});
	}
	
	if(document.querySelectorAll('.module--articlesVideoGallery .swiper').length)
	{
		let player;

		if(document.querySelectorAll('.module--articlesVideoGallery .swiper .swiper-slide').length > 1) {
			let videoGallerySlider = new Swiper('.module--articlesVideoGallery .swiper', {
				spaceBetween: 0,
				slidesPerView: 1,
				loop: true,
				centeredSlides: true,
				navigation: {
					nextEl: '.module--articlesVideoGallery .swiper .btn-next',
					prevEl: '.module--articlesVideoGallery .swiper .btn-prev',
				}
			});
			
			function videoSlideChangedHandler(){
				let slide = document.querySelectorAll('.module--articlesVideoGallery .swiper .swiper-slide-active');
				if(player !== undefined)
				{
					player.destroy();
					player = undefined;
				}
				document.querySelectorAll('.module--articlesVideoGallery .swiper .swiper-slide').forEach(slide => {
					let button = slide.querySelectorAll('.btn--play')[0];
					let credits = slide.querySelectorAll('.image-credit');
					credits = credits.length > 0 ? credits[0] : null;
					button.classList.remove('invisible');
					if(credits !== null)
						credits.classList.remove('invisible');
				});
			}
	
			videoGallerySlider.on('slideChangeTransitionEnd', function () {
				videoSlideChangedHandler();
			});
		}


		function YouTubeGetID(url){
			url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
			return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
		}


		document.querySelectorAll('.module--articlesVideoGallery .swiper .swiper-slide').forEach(slide => {
			let button = slide.querySelectorAll('.btn--play')[0];
			button.addEventListener('click', function(e) {
				let videoContainer = slide.querySelectorAll('.videoContainer')[0];
				let credits = slide.querySelectorAll('.image-credit');
				credits = credits.length > 0 ? credits[0] : null;
				let button = this;
				if(player === undefined) {
					player = new YT.Player(videoContainer, {
						width: slide.offsetWidth,
						height: slide.offsetHeight < 240 ? 240 : slide.offsetHeight,
						videoId: YouTubeGetID(slide.dataset.youtube),
						playerVars: {
							color: 'white'
						},
						events: {
							onReady: function(){
								player.playVideo();
							},
							onStateChange: function(e){
								if (e.data == YT.PlayerState.PAUSED || e.data == YT.PlayerState.ENDED) {
									button.classList.remove('invisible');
									if(credits !== null)
										credits.classList.remove('invisible');
								} else {
									button.classList.add('invisible');
									if(credits !== null)
										credits.classList.add('invisible');
								}
							}
						}
					});
				} else {
					player.playVideo();
				}
			});
		});
	}

	if(document.querySelectorAll('.module--promotedArticles .swiper').length && document.querySelectorAll('.module--promotedArticles .swiper .swiper-slide').length > 1)
	{
		let moduleSlider = new Swiper('.module--promotedArticles .swiper', {
			spaceBetween: 10, // EXP
			slidesPerView: 1,
			loop: true,
			centeredSlides: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.module--promotedArticles .dot-container',
				type: 'bullets',
			},
			navigation: {
				nextEl: '.module--promotedArticles .swiper .arrow-next',
				prevEl: '.module--promotedArticles .swiper .arrow-prev',
			}
		});
	
		function positionHomeSliderNav() {
			let sliderNavigation = document.querySelectorAll('.module--promotedArticles .swiper .swiper-navigation');
			let slide = document.querySelectorAll('.module--promotedArticles .swiper .swiper-slide-active');
			// if(sliderNavigation.length)
			// {
			// 	sliderNavigation = sliderNavigation[0];
			// 	slide = slide[0];
			// 	slide = slide.querySelector('._wr');
			// 	sliderNavigation.style.left = (slide.getBoundingClientRect().left + slide.getBoundingClientRect().width - sliderNavigation.getBoundingClientRect().width - 30) + 'px';
			// }
		}
		
		function slideChangedHandler(){
			let slide = document.querySelectorAll('.module--promotedArticles .swiper .swiper-slide-active');
			let sliderNavigation = document.querySelectorAll('.module--promotedArticles .swiper .swiper-navigation');
			if(sliderNavigation.length)
			{
				sliderNavigation = sliderNavigation[0];
				slide = slide[0];
				let color = slide.getAttribute("color");
				//Colors
				document.querySelectorAll('.module--promotedArticles .swiper .swiper-navigation button').forEach(button => {
					button.classList.remove(
						'btn--arrow--black',
						'btn--arrow--white',
						'btn--arrow--blue',
						'btn--arrow--lightGreen',
						'btn--arrow--orange',
						'btn--arrow--red',
						'btn--arrow--pink',
						'btn--arrow--turquoise',
						'btn--arrow--yellow',
						'btn--arrow--brightGreen',
						'btn--arrow--aqua',
						'btn--arrow--peach'
					  );
					button.classList.add(`btn--arrow--${color}` );
				}); 
			}
		}
		
		moduleSlider.on('breakpoint', function () {
			positionHomeSliderNav();
		});
		
		moduleSlider.on('slideChangeTransitionEnd', function () {
			slideChangedHandler();
		});
		
		window.addEventListener("resize", function(){
			positionHomeSliderNav();
		});
	
		positionHomeSliderNav();
		slideChangedHandler();
	}

	if(document.querySelectorAll('.module--featuredEvents .swiper').length && document.querySelectorAll('.module--featuredEvents .swiper .swiper-slide').length > 1)
	{	
		if(window.innerWidth <= 767){
			let moduleSlider = new Swiper('.module--featuredEvents .module-mobile .swiper', {
				spaceBetween: 10,
				slidesPerView: 1,
				loop: true,
				centeredSlides: true,
				// autoplay: {
				// 	delay: 2500, 
				// 	disableOnInteraction: false, 
				// },
				pagination: {
					el: '.module--featuredEvents .dot-container',
					type: 'bullets',
				},
			});
		}

		if(window.innerWidth > 767){
			let moduleSlider = new Swiper('.module--featuredEvents .module-desktop .swiper', {
				spaceBetween: 10,
				slidesPerView: 1,
				loop: false,
				centeredSlides: true,
				autoplay: {
					delay: 2500, 
					disableOnInteraction: false, 
				},
				navigation: {
					nextEl: '.module--featuredEvents .swiper .btn-next',
					prevEl: '.module--featuredEvents .swiper .btn-prev',
				}
			});

			let paginationItems = document.querySelectorAll('.module--featuredEvents .pagination-item');

			if(paginationItems != null ){
				paginationItems.forEach(function (item, index) {
					item.addEventListener('click', function () {
						paginationItems.forEach((paginationItem) =>{
							paginationItem.classList.remove('active');
						})

						item.classList.toggle("active");
						moduleSlider.slideTo(index);
					});
				});
			}

			function updatePagination() {
				var paginationItems = document.querySelectorAll('.pagination-item');

				for (var i = 0; i < paginationItems.length; i++) {
					if (moduleSlider.activeIndex === i) {
						paginationItems[i].classList.add('active');
					} else {
						paginationItems[i].classList.remove('active');
					}
				}
			}

			moduleSlider.on('slideChange', function () {
				updatePagination();
			});

			updatePagination();
		}

		
		// function positionHomeSliderNav() {
		// 	let sliderNavigation = document.querySelectorAll('.module--featuredEvents .swiper .swiper-navigation');
		// 	let slide = document.querySelectorAll('.module--featuredEvents .swiper .swiper-slide-active');
		// }

		// function slideChangedHandler(){
		// 	let slide = document.querySelectorAll('.module--featuredEvents .swiper .swiper-slide-active');
		// 	let sliderNavigation = document.querySelectorAll('.module--featuredEvents .swiper .swiper-navigation');
		// 	if(sliderNavigation.length)
		// 	{
		// 		sliderNavigation = sliderNavigation[0];
		// 		slide = slide[0];
		// 		let color = slide.getAttribute("color");
		// 		//Colors
		// 		document.querySelectorAll('.module--featuredEvents .swiper .swiper-navigation button').forEach(button => {
		// 			button.classList.remove(
		// 				'btn--arrow--black',
		// 				'btn--arrow--white',
		// 				'btn--arrow--blue',
		// 				'btn--arrow--lightGreen',
		// 				'btn--arrow--orange',
		// 				'btn--arrow--red',
		// 				'btn--arrow--pink',
		// 				'btn--arrow--turquoise',
		// 				'btn--arrow--yellow',
		// 				'btn--arrow--brightGreen',
		// 				'btn--arrow--aqua',
		// 				'btn--arrow--peach'
		// 			  );
		// 			button.classList.add(`btn--arrow--${color}` );
		// 		}); 
		// 	}
		// }
		
		// moduleSlider.on('breakpoint', function () {
		// 	positionHomeSliderNav();
		// });
		
		// moduleSlider.on('slideChangeTransitionEnd', function () {
		// 	slideChangedHandler();
		// });
		
		// window.addEventListener("resize", function(){
		// 	positionHomeSliderNav();
		// });
	
		// positionHomeSliderNav();
		// slideChangedHandler();
	}
};